module.exports = ".navbar{box-shadow:none !important}b{font-weight:bold}\n"